import CheckIcon from '@mui/icons-material/Check';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';
import * as React from 'react';
import { memo } from 'react';

import { StyledFormGroup } from './Checkbox.style';

// Standard Styled checkbox
export const Checkbox = memo(function Checkbox({
    label,
    ...rest
}: { label: React.ReactElement | string } & CheckboxProps) {
    return (
        <StyledFormGroup>
            <FormControlLabel
                control={<MuiCheckbox {...rest} icon={<span />} checkedIcon={<CheckIcon />} />}
                label={label}
            />
        </StyledFormGroup>
    );
});
